export default __webpack_public_path__ + "static/media/icon_potret.ce4e7d4f.svg";